import {
  Card,
  InputLabel,
  InputSelectField,
  InputWrapper,
  Modal,
  ModalCloseButton,
  MtFormButtons,
  SectionTitle,
} from '@presentation/components';
import { Formik } from 'formik';
import type { FC } from 'react';
import type { ModalAddLanguageProps, ModalAddLanguageValues } from './types';

export * from './types';

export const ModalAddLanguage: FC<ModalAddLanguageProps> = (props) => {
  const { modal, form, onCancelClick } = props;

  return (
    <Modal {...modal}>
      <Card size="small" isModal>
        <ModalCloseButton modal={modal} />
        <Formik<ModalAddLanguageValues> {...form} enableReinitialize>
          {({ submitForm, resetForm }) => (
            <>
              <SectionTitle>Add language</SectionTitle>
              <InputWrapper>
                <InputLabel>Language</InputLabel>
                <InputSelectField name="language" options={form.options.languages} />
              </InputWrapper>

              <MtFormButtons
                showCancel
                showSubmit
                onSubmitClick={() => submitForm()}
                onCancelClick={(event) => {
                  resetForm();
                  onCancelClick?.(event);
                }}
              />
            </>
          )}
        </Formik>
      </Card>
    </Modal>
  );
};
